import TripsByDirection from '@/components/manage/tickets/TripsByDirection';
import { manageFlowBookingSelector } from '@/features/manage/manageSelectors';
import { useBookingTrips } from '@/hooks/useBookingTrips';
import { useSelector } from '@/store/utils';
import type { CheckoutOrBookingPassengerMap } from '@/types/passenger';
import { tripIsRenderable } from '@/utils/booking';
import { Divider } from '@packages/webshop-design-system';
import type { FC } from 'react';

interface BookedTripsDetailsProps {
  passengersMap: CheckoutOrBookingPassengerMap;
}

const Tickets: FC<BookedTripsDetailsProps> = ({ passengersMap }) => {
  const booking = useSelector(manageFlowBookingSelector);
  const { outboundTrips, inboundTrips } = useBookingTrips(booking);

  // Drop trips whose passengers were all moved off via change-booking — their
  // admissions are all EXCHANGED, so they'd otherwise render as empty trips
  // (no passenger count, no leg cards). Terminal admissions like REFUNDED are
  // kept, so a refunded booking still shows its (grayed-out) tickets. Filtering
  // here keeps the per-direction header counts and the return-section gating
  // consistent with what renders.
  const renderableOutboundTrips = outboundTrips.filter(tripIsRenderable);
  const renderableInboundTrips = inboundTrips.filter(tripIsRenderable);

  return (
    <div className="flex flex-1 flex-col">
      <TripsByDirection
        trips={renderableOutboundTrips}
        passengersMap={passengersMap}
        header="outboundTrips"
      />
      {!!renderableInboundTrips.length && (
        <>
          <Divider className="my-4" grow={false} />
          <TripsByDirection
            trips={renderableInboundTrips}
            passengersMap={passengersMap}
            header="returnTrip"
          />
        </>
      )}
    </div>
  );
};

export default Tickets;
